export const getNewsletterValues = (values?) => {
  let additionalValues = {};
  switch (values?.Language) {
    case 'de_german':
      additionalValues = {
        NL_Source_Website: 'www.walterknoll.de',
        Language: 'German',
      };
      break;
    case 'de_english':
      additionalValues = {
        NL_Source_Website: 'www.walterknoll.de',
        Language: 'English',
      };
      break;
    case 'us_english':
      additionalValues = {
        NL_Source_Website: 'www.walter-k.com',
        Language: 'English',
      };
      break;
  }
  // Add values coming from the newsletter redirect in the query string
  return additionalValues;
};
